const MEDIA_DATA = [
  {
    title: '顶流明星最新动态全追踪',
    desc: '近期多位顶流明星动态频出，从片场路透到私人行程，全方位追踪不遗漏。',
    duration: '15:28',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20style%20with%20dramatic%20warm%20lighting%2C%20red%20carpet%20atmosphere%2C%20play%20button%20overlay%20on%20dark%20background%2C%20entertainment%20news%20aesthetic%2C%20glamorous%20vibe%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography%2C%20deep%20contrast%20with%20golden%20accents&width=800&height=450&seq=media-1-2026&orientation=landscape',
  },
  {
    title: '综艺节目幕后不为人知的故事',
    desc: '热门综艺录制背后的精彩花絮和制作团队独家揭秘。',
    duration: '22:05',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=TV%20studio%20production%20set%20with%20warm%20professional%20lighting%2C%20camera%20equipment%20silhouette%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20composition%2C%20dark%20rich%20background%2C%20no%20text%2C%20no%20people%2C%20editorial%20style%2C%20golden%20warm%20glow&width=800&height=450&seq=media-2-2026&orientation=landscape',
  },
  {
    title: '年度十大娱乐名场面回顾',
    desc: '盘点今年最令人难忘的十个娱乐瞬间，哪一个最让你印象深刻？',
    duration: '18:42',
    views: '156万',
    img: 'https://readdy.ai/api/search-image?query=Montage%20style%20with%20warm%20golden%20spotlights%2C%20cinematic%20award%20ceremony%20atmosphere%2C%20dramatic%20stage%20lighting%2C%20celebration%20confetti%2C%20dark%20elegant%20background%2C%20editorial%20photography%2C%20no%20text%2C%20no%20faces%2C%20vibrant%20warm%20tones&width=800&height=450&seq=media-3-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-play-circle-line text-primary-500 mr-2"></i>精彩视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500">精选黑料吃瓜高清视频，热门内容一网打尽</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_DATA.map((item, idx) => (
            <article
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-2xl ml-1"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-black/70 text-white text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}